﻿/**
 *
 * nddung2 25.03.2025
 */
export default {
  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình tổng hợp dự toán sau kiểm tra
  /// </summary>
  SummaryAfterAudit: 1,

  /// <summary>
  /// chức năng "In" tại màn hình lập dự toán
  /// </summary>
  Estimate: 2,

  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình tổng hợp dự toán sau lập toàn ngành
  /// </summary>
  Summary: 3,

  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình nộp dự toán tab Nhu cầu
  /// </summary>
  SendEstimateDemand: 4,

  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình nộp dự toán tab kiểm tra
  /// </summary>
  SendEstimate: 5,
  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình kiểm tra dự toán tab nhu cầu
  /// </summary>
  AuditReceive: 6,
  /// <summary>
  /// chức năng "Thuyết minh" tại màn hình kiểm tra dự toán tab kiểm tra
  /// </summary>
  AuditEstimate: 7,
};
